module.exports = __webpack_public_path__ + "img/aseguradora-2.3c2296be.png";